<template>
    <v-card>                        
        <v-card-title>
            Manage Role "{{ targetRole }}" Services
            <v-spacer></v-spacer>
            <v-text-field v-model="searchRoleServices" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-card-text>
            <feathers-vuex-find service="service-lists" :query="{}" watch="query">
                <v-container slot-scope="{ items: desserts, isFindPending }">
                    
                    <v-data-table :headers="roleServicesHeader" :loading="isFindPending" :items="desserts" :search="searchRoleServices">
                        <template v-slot:item.id="{ item }">
                            <b>{{ item.id }}</b>
                        </template>
                        <template v-slot:item.methods="{ item }">
                            <v-chip x-small v-for="(method, index) in (isEnable(item) && item.rules.roles[targetRole] || { methods: [] }).methods" class="ma-2" color="cyan" text-color="white" :key="index">{{ method }}</v-chip>
                            <v-chip x-small v-if="isEnable(item) && item.rules.roles[targetRole].methods.length === 0" class="ma-2" color="red" text-color="white">Not Accessible</v-chip>
                            <v-chip x-small v-if="!isEnable(item)" class="ma-2" color="blue-grey" text-color="white">Default</v-chip>
                        </template>
                        <!-- <template v-slot:item.authenticate="{ item }">
                            <v-chip x-small v-for="(method, index) in (isEnable(item) && item.rules.roles[targetRole] || { authenticate: [] }).authenticate" class="ma-2" color="secondary" text-color="white" :key="index">{{ method }}</v-chip>
                            <v-chip x-small v-if="isEnable(item) && item.rules.roles[targetRole].authenticate.length === 0" class="ma-2" color="primary" text-color="white">No Authentication Required</v-chip>
                            <v-chip x-small v-if="!isEnable(item)" class="ma-2" color="cyan" text-color="white">Default</v-chip>
                        </template> -->
                        <template v-slot:item.owner="{ item }">
                            <v-chip x-small v-if="isEnable(item)" class="ma-2" :color="item.rules.roles[targetRole].owner.enable ? `green` : `red`" text-color="white">{{ item.rules.roles[targetRole].owner.enable ? item.rules.roles[targetRole].owner.field : 'Disabled' }}</v-chip>
                            <v-chip x-small v-if="!isEnable(item)" class="ma-2" color="blue-grey" text-color="white">Default</v-chip>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <modify-service-dialog :item="item" :target-role="targetRole" @success="onSuccess" @error="onError" />
                        </template>
                    </v-data-table>

                </v-container>
            </feathers-vuex-find>  
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small color="red" text @click="$emit('close')">Done</v-btn>
        </v-card-actions>
    </v-card>
    
</template>

<script>
import ModifyServiceDialog from './ModifyServiceDialog';

export default {
    props: {
        targetRole: String
    },
    data() {
        return {
            searchRoleServices: '',
            roleServicesHeader: [
                {
                    text: 'Services',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'Accessable Methods',
                    align: 'end',
                    sortable: false,
                    value: 'methods'
                },
                // {
                //     text: 'Authentication Required',
                //     align: 'end',
                //     sortable: false,
                //     value: 'authenticate'
                // },
                {
                    text: 'Owner Only',
                    align: 'end',
                    sortable: false,
                    value: 'owner'
                },
                {
                    text: 'Actions',
                    align: 'center',
                    sortable: false,
                    value: 'actions'
                }
            ]
        };
    },
    methods: {
        isEnable(item) {
            return item.rules.roles && item.rules.roles[this.targetRole] && item.rules.roles[this.targetRole].enable;
        },
        onSuccess() {
            this.$emit('success');
        },
        onError(err) {
            this.$emit('error', err);
        }
    },
    components: {
        ModifyServiceDialog
    }
};
</script>